import { withTheme } from '../config';
import { Icon, } from '@rneui/base/dist/Icon/Icon';
export { Icon };
export default withTheme(Icon, 'Icon');
